function Togo({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_2312)">
  <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#FFDA44"/>
  <path d="M16.0001 0C15.9884 0.000125 15.3044 6.4 15.3044 6.4H28.8008C25.8818 2.51394 21.2346 0 16.0001 0Z" fill="#496E2D"/>
  <path d="M16 31.9996C21.2345 31.9996 25.8817 29.4857 28.8007 25.5996H3.19934C6.11834 29.4857 10.7655 31.9996 16 31.9996Z" fill="#496E2D"/>
  <path d="M31.6797 12.7998H15.3044L16.0001 19.1998H31.6797C31.8897 18.1659 32.0001 17.0957 32.0001 15.9998C32.0001 14.9039 31.8896 13.8337 31.6797 12.7998Z" fill="#496E2D"/>
  <path d="M16 19.2C16 15.8609 16 3.7565 16 0C7.1635 0 0 7.1635 0 16C0 17.0959 0.1105 18.1661 0.320375 19.2H16Z" fill="#D80027"/>
  <path d="M8.82857 7.65234L9.86457 10.8408H13.2174L10.5051 12.8116L11.5409 16.0002L8.82857 14.0295L6.11619 16.0002L7.15225 12.8116L4.43994 10.8408H7.79263L8.82857 7.65234Z" fill="#F0F0F0"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default Togo;
